<template>
  <div class="d-flex-column flex-65 justify-start align-start t-white gap-40">
    <template v-if="!$isMobile() && !$isTablet()">
      <FcCoachingBoost v-if="currentGamePackSlug === 'fc-coins-boost'" />
      <FcCoachingBoost v-if="currentGamePackSlug === 'fc-coaching-boost'" />
      <FcCoachingBoost
        v-if="currentGamePackSlug === 'fc-squad-battles-boost'"
      />
      <FcCoachingBoost v-if="currentGamePackSlug === 'fc-objectives-boost'" />
      <FcCoachingBoost
        v-if="currentGamePackSlug === 'fc-fut-champions-final-boost'"
      />
      <FcCoachingBoost
        v-if="currentGamePackSlug === 'fc-fut-champions-playoffs-boost'"
      />
      <FcCoachingBoost
        v-if="currentGamePackSlug === 'fc-division-rivals-boost'"
      />
      <FcCoachingBoost
        v-if="currentGamePackSlug === 'fc-division-rivals-wins-boost'"
      />
      <FcCoachingBoost v-if="currentGamePackSlug === 'fc-tots-cup-boost'" />
    </template>

    <template v-if="$isMobile() || $isTablet()">
      <PackTiming v-if="gameStore.getGamePack?.pack_slots" />
    </template>

    <div class="d-flex-column justify-start xl-hide gap-24">
      <div class="d-flex-column justify-start align-start gap-5">
        <label class="t-white font-family-1 title-h5 f-w-600">{{
          $t("new.info")
        }}</label>
        <p class="t-grey regular-l font-family-2">
          {{ $t(`fc-boost.info_desc.${currentGamePackSlug}`) }}
        </p>
      </div>

      <div class="d-flex-column justify-start align-start gap-6">
        <Info
          :title="$t('membership.membership_8_title')"
          v-if="gameStore.getGamePack?.rewards?.length > 0"
          :infos="gameStore.getGamePack?.rewards"
        />
        <Info
          :title="$t('new.requirements')"
          v-if="gameStore.getGamePack?.requirements?.length > 0"
          :infos="gameStore.getGamePack?.requirements"
        />
        <Info
          :title="$t('homepage.faq')"
          v-if="gameStore.getGamePack?.faqs?.length > 0"
          :infos="gameStore.getGamePack?.faqs"
          type="faq"
        />
      </div>
    </div>
  </div>

  <div
    class="d-flex-column justify-start align-start t-white cart_container"
    style="flex: 0.225"
  >
    <WhyWeCheap />
    <Cart />
    <SafeSecurePayments />
    <div
      class="d-flex-column justify-start align-start"
      v-if="$isMobile() || $isTablet()"
      style="margin-top: 20px"
    >
      <FcCoachingBoost />
    </div>
    <div
      class="d-flex-column justify-start above-xl-hide"
      style="margin-top: 24px"
    >
      <div class="d-flex-column justify-start align-start gap-6">
        <Info
          :title="$t('membership.membership_8_title')"
          v-if="gameStore.getGamePack?.rewards?.length > 0"
          :infos="gameStore.getGamePack?.rewards"
        />
        <Info
          :title="$t('new.requirements')"
          v-if="gameStore.getGamePack?.requirements?.length > 0"
          :infos="gameStore.getGamePack?.requirements"
        />
        <Info
          :title="$t('homepage.faq')"
          v-if="gameStore.getGamePack?.faqs?.length > 0"
          :infos="gameStore.getGamePack?.faqs"
          type="faq"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import Cart from "../calculators/checkout/Cart.vue";
import SafeSecurePayments from "../calculators/checkout/SafeSecurePayments.vue";
import FcCoachingBoost from "../calculators/fc-25/FcCoachingBoost.vue";
import PackTiming from "~/components/common/PackTiming.vue";

import Info from "../custom/Info.vue";
import WhyWeCheap from "../custom/WhyWeCheap.vue";
const { currentGamePackSlug } = useGameComposable();

const gameStore = useGameStore();
</script>
